var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCopyAttach(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 13.0004L11.4534 13.9538C12.2039 14.7043 13.2217 15.1259 14.2831 15.1259C15.3444 15.1259 16.3623 14.7043 17.1128 13.9538L20.145 10.9215C21.958 9.10839 21.958 6.16893 20.145 4.35579V4.35579C18.3319 2.54286 15.3924 2.54286 13.5793 4.35579L12.6919 5.24416",
    stroke: "#0000FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4969 9.99955L13.5435 9.04616C12.793 8.29565 11.7752 7.87402 10.7138 7.87402C9.65249 7.87402 8.63462 8.29565 7.88415 9.04616L4.85189 12.0784C3.03895 13.8916 3.03895 16.831 4.85189 18.6442V18.6442C6.66503 20.4571 9.60449 20.4571 11.4176 18.6442L12.305 17.7558",
    stroke: "#0000FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopyAttach);
export default __webpack_public_path__ + "static/media/icon_copy-attach.1a196779ad31da1c8e2935a3733abb8b.svg";
export { ForwardRef as ReactComponent };